import { connect } from 'react-redux'
import { toggleNavbarTransparent } from '../actions/navbar'
import ComingSoon from '../components/ComingSoon'

const mapStateToProps = state => ({
    // openDrawer: state.navDrawers.isOpen,
    // originalNavState: (state.navBar && state.navBar.originalNav) || false
})

const mapDispatchToProps = dispatch => ({
    toggleNavbarTransparent: () => dispatch(toggleNavbarTransparent()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ComingSoon)